import { pleaseConfirm } from "../utils/common";
var VARIANTS = {
  ARHI: "health insurance",
  IMAN: "Australian health insurance",
  IWHI: "Australian health insurance",
  ISHI: "OSHC health insurance"
};
var validPartnerTransferringFundsRadio = function validPartnerTransferringFundsRadio(value) {
  var funnel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "ARHI";
  var fieldName = arguments.length > 2 ? arguments[2] : undefined;
  var error; // eslint-disable-line init-declarations
  if (!value) {
    error = pleaseConfirm("if your partner currently has ".concat(fieldName || VARIANTS[funnel] || VARIANTS.ARHI));
  }
  return error;
};
export default validPartnerTransferringFundsRadio;